import script from "./anchor-link.vue?vue&type=script&setup=true&lang=ts"
export * from "./anchor-link.vue?vue&type=script&setup=true&lang=ts"

import "./anchor-link.vue?vue&type=style&index=0&id=efbdbf52&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-efbdbf52"]])

export default __exports__